import React, { type FC } from 'react';
import {
	IsFhsEnabledProvider,
	type IsFhsEnabledProviderProps,
} from '@atlaskit/navigation-system/fhs-rollout';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';

const ChildrenOnly: FC<IsFhsEnabledProviderProps> = ({ children }) => <>{children}</>;

// Remove entire package when cleaning up navx-2731-convert-jira-fhs-rollout
export const IsFhsEnabledProviderNavx2731 = componentWithFG(
	'navx-2731-convert-jira-fhs-rollout',
	IsFhsEnabledProvider,
	ChildrenOnly,
);
